<template>
    <layout-machine-introduction :unsaved-puri-count="unsavedPuriCount"
                                 :latest-image-id="latestImageId"
                                 :is-searchable="isSearchable"
                                 :machine-id="machineId"
                                 :section-title-list="sectionTitleList"
                                 youtube-url="https://youtube.com/shorts/EmzWyyJY5uc"
                                 :has-title-anchor-link="false"
                                 :has-top-border-anchor-link="false"
    >
        <template v-slot:content-1>
            <p class="img-01"><img :src="buildImgUrl('contents_01_01.png')" alt="うるっとおめめ うるおいぷにっと肌"></p>
            <p class="img-02"><img :src="buildImgUrl('contents_01_02.png')" alt="これがマイパレットのうるみ盛れ"></p>
            <p class="img-03"><img :src="buildImgUrl('contents_01_03.png')" alt="画角はタテとヨコ選べちゃうよ"></p>
        </template>
        <template v-slot:content-2>
            <p class="img-01"><img :src="buildImgUrl('contents_02_01.png')" alt="セルフショットタイムはカラーライトが選べて超楽しい"></p>
            <p class="img-02"><img :src="buildImgUrl('contents_02_02.png')" alt="魅力が異なる2つのプランを用意！フォトプラン プリのカメラで3連写撮影！"></p>
            <p class="img-03"><img :src="buildImgUrl('contents_02_03.png')" alt="フォトプランイメージ"></p>
            <p class="img-04"><img :src="buildImgUrl('contents_02_04.png')" alt="3連写チャレンジ！遊び方は無限大"></p>
            <p class="img-05"><img :src="buildImgUrl('contents_02_05.png')" alt="スマホプラン 自分のスマホで60秒撮り放題！"></p>
            <p class="img-06"><img :src="buildImgUrl('contents_02_06.png')" alt="お気に入りのアプリで盛れて楽しみ方は無限大"></p>
            <p class="img-07"><img :src="buildImgUrl('contents_02_07.png')" alt="魚眼ミラーで全身撮影も"></p>
        </template>
        <template v-slot:content-3>
            <p class="img-01"><img :src="buildImgUrl('contents_03_01.png')" alt="一覧表示で細かく調整できるからワタシ好みに超盛れる"></p>
            <p class="img-02"><img :src="buildImgUrl('contents_03_02.png')" alt="プリイメージ"></p>
            <p class="img-03"><img :src="buildImgUrl('contents_03_03.png')" alt="一発で可愛くなれるセット機能でワタシだけの可愛いが見つかる"></p>
            <p class="img-04"><img :src="buildImgUrl('contents_03_04.gif')" alt="動画イメージ"></p>
        </template>
        <template v-slot:content-4>
            <p class="img-01"><img :src="buildImgUrl('contents_04_01.png')" alt="マイパレットの超可愛いシールデザインでワタシだけのお気に入りが見つかる"></p>
            <p class="img-02"><img :src="buildImgUrl('contents_04_02.png')" alt="プリイメージ"></p>
            <p class="img-03"><img :src="buildImgUrl('contents_04_03.png')" alt="SEAL IMAGE"></p>
            <p class="img-04"><img :src="buildImgUrl('contents_04_04.png')" alt="プリイメージ"></p>
        </template>
    </layout-machine-introduction>
</template>

<script>
import LayoutMachineIntroduction from "../../templates/LayoutMachineIntroduction.vue";
import * as urlUtil from "../../../util/UrlUtil";
import {mapActions} from "vuex";

export default {
    name: "MachineMyPalette1",
    components: { LayoutMachineIntroduction },
    data() {
        return {
            machineId: 149,
            sectionTitleList: [
                '1 ちゃんと可愛い うるみ盛れ',
                '2 まるでセルフ写真館!? セルフショットタイム',
                '3 カンタンに可愛くなれる MYレタッチ & MYメイク',
                '4 オシャレ&シンプルに可愛い シールデザイン',
            ],
        }
    },
    props: {
        /**
         * Headerコンポーネント用
         * 未保存プリ数
         */
        unsavedPuriCount: {
            type: String,
            required: true
        },
        /**
         * Headerコンポーネント用
         * 最新プリID
         */
        latestImageId: {
            type: String,
            required: true
        },
        /**
         * 当該機種が「遊べるお店を探す」によって検索可能であるかどうかを判定する.
         * toolboxから取得
         * 「遊べるお店を探す」表示判定
         */
        isSearchable: {
            type: Boolean,
            required: true
        },
    },
    mounted() {
        /**
         * TheHeader,TheFooterでstoreのaccountStatusを使用するため、予めstoreに保存しておく
         * FIXME:ここでの取得を忘れてもエラーが出ず気づかない可能性があるため、VOYAGERFRONT-5558で修正予定
         */
        this.getAccountStatus()
    },
    methods: {
        ...mapActions({
            getAccountStatus: 'AccountStoreV2/getAccountStatus'
        }),
        /**
         * 画像のURLを組み立てる
         * @param {string} imgName 画像名
         */
        buildImgUrl(imgName) {
            return urlUtil.imageUrlUtil.machineIntroductionImageUrl(String(this.machineId), imgName)
        },
        /**
         * cssのurl関数の呼び出し部分の含めた文字列を返す
         * styleタグ内でv-bindで使用することを想定している
         */
        buildStyleImgUrl(imageName) {
            const imgUrl = this.buildImgUrl(imageName)
            return `url(${imgUrl})`;
        },
    }
}
</script>

<style scoped lang="scss">
@use "../../../../scss/v2/base/variables";
@use "sass:math";

$deviceWidth: 750px;

:deep(*) {
    .c-machine-introduction {
        &-top {
            .btn-puri-list {
                width: math.percentage(math.div(162px, $deviceWidth));
                top: math.percentage(math.div(220px, $deviceWidth));
                left: math.percentage(math.div(20px, $deviceWidth));
            }

            .btn-shop-list {
                position: absolute;
                top: math.percentage(math.div(415px, $deviceWidth));
                padding: 0;
                width: 100%;
                &-link {
                    margin: auto;
                    width: math.percentage(math.div(536px, $deviceWidth));
                    a {
                        display: block;
                    }
                }
            }

            .list-anchor-link {
                padding: 25px 0 35px;
                background: variables.$color-white;

                .img-link {
                    width: math.percentage(math.div(654px, $deviceWidth));
                }

                .img-line {
                    width: math.percentage(math.div(654px, $deviceWidth));
                    display: block;
                    margin: auto;
                }
            }
        }

        &-contents {
            .accordion-inner {
                text-align: center;

                &.cont-3 {
                    padding: 0 0 29px;

                    .img-04{
                        width: math.percentage(math.div(695px, $deviceWidth));
                        margin: 0 auto;
                    }
                }
            }
        }

        &-movie {
            padding: 33px 0 133px;
            background-image: v-bind("buildStyleImgUrl('youtube_back.png')");
            background-repeat: no-repeat;
            background-position: center;
            background-size: cover;

            &-thumb {
                width: math.percentage(math.div(651px, $deviceWidth));
                margin: 0 auto;
            }
        }
    }
}

</style>
